// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2xI9k","validationTips":"StatementDescriptor_validationTips__1vRGn"};